import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import useErrorHelper from '../../hooks/useErrorHelper.tsx';
import './integrate_template.scss';
import { navigate, usePathParams, useQueryParams } from 'raviger';
import { useTemplate } from '../../hooks/useTemplate.tsx';
import { Button, Card, Form, FormLayout, Page, Spinner, TextField, Text, } from '@shopify/polaris';
import { DrawTypeEnum } from '../../editor/types.ts';
import { BuildRenderUrl } from '../../Utils.tsx';
import { HOST } from '../../Constants.ts';
import { useStore } from '../../stores';
import usePromptModalHelper from '../../hooks/usePromptModalHelper.tsx';
import { useTemplateDelete } from '../../hooks/useTemplateDelete.tsx';
import CrispSpacer from '../../components/CrispSpacer.tsx';
import IntegrateCard from '../../components/IntegrateCard/Index.tsx';
const loader_base64 = 'data:image/gif;base64,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';
const IntegrateTemplate = () => {
    const userInfo = useStore((state) => state.user);
    const props = usePathParams('/integrate_template/:id');
    const [query] = useQueryParams();
    if (!props) {
        useEffect(() => {
            navigate('/');
        }, []);
        return;
    }
    const [render, setRender] = useState({
        in_progress: true,
        image: '',
        url: '',
    });
    const deleteTemplateCallback = useTemplateDelete(props.id);
    const [setErrorMessage, ErrorModal] = useErrorHelper();
    const [isPromptModalOpen, setIsPromptModalOpen] = useState(false);
    const [PromptModal] = usePromptModalHelper(isPromptModalOpen, 'To delete template please type DELETE in the input below', 'text', 'delete', '', (value) => {
        if (value === 'DELETE') {
            setIsPromptModalOpen(false);
            deleteTemplateCallback().then(() => {
                navigate('/');
            });
        }
        else {
            setIsPromptModalOpen(false);
            setErrorMessage('your prompt is not DELETE');
        }
    }, () => {
        setIsPromptModalOpen(false);
    });
    const [renderUrl, setRenderUrl] = useState(undefined);
    const [displayRenderUrl, setDisplayRenderUrl] = useState('');
    const [integrate_template, error, isLoading] = useTemplate(props.id);
    const [cardSizes, setCardSizes] = useState({
        width: 0,
        height: 0,
    });
    let containerRef = useRef(null);
    useEffect(function () {
        const calculateSizes = () => {
            if (integrate_template &&
                containerRef &&
                containerRef.current !== null) {
                setCardSizes({
                    width: containerRef.current.clientWidth,
                    height: Math.floor((containerRef.current.clientWidth *
                        integrate_template.template_json.height) /
                        integrate_template.template_json.width),
                });
            }
        };
        calculateSizes();
        window.addEventListener('resize', calculateSizes);
        return () => {
            window.removeEventListener('resize', calculateSizes);
        };
    }, [containerRef.current, setCardSizes, integrate_template]);
    let [editableFields, setEditableFields] = useState([]);
    useEffect(() => {
        if (integrate_template) {
            let fields_to_edit = integrate_template.template_json.state
                .filter((i) => [DrawTypeEnum.Image, DrawTypeEnum.Text].includes(i.type))
                .map((i) => ({
                name: `${i.type}${i.id}`,
                type: i.type,
                value: i.type === DrawTypeEnum.Text ? i.text : i.link,
            }));
            setEditableFields(fields_to_edit);
            setRenderUrl(BuildRenderUrl(HOST, integrate_template._id, userInfo.secret_key, fields_to_edit));
        }
    }, [integrate_template, userInfo]);
    useEffect(() => {
        if (renderUrl) {
            setRender({
                in_progress: true,
                url: renderUrl,
                image: '',
            });
            fetch(renderUrl).then(async (response) => {
                if (response.ok) {
                    let json = await response.json();
                    // return json;
                    setRender((prevState) => {
                        if (prevState.url === renderUrl) {
                            return {
                                in_progress: false,
                                image: json.image,
                                url: renderUrl,
                            };
                        }
                        else {
                            return prevState;
                        }
                    });
                }
                else {
                    let error, json;
                    try {
                        json = await response.json();
                    }
                    catch (e) { }
                    if (json && json.message) {
                        error = new Error(json.message);
                    }
                    else {
                        error = new Error(response.statusText);
                    }
                    if (error) {
                        setErrorMessage(error.message);
                    }
                    setRender((prevState) => {
                        if (prevState.url === renderUrl) {
                            return {
                                in_progress: false,
                                image: null,
                                url: renderUrl,
                            };
                        }
                        else {
                            return prevState;
                        }
                    });
                }
            });
        }
    }, [renderUrl]);
    useEffect(function () {
        if (integrate_template && userInfo && editableFields) {
            setDisplayRenderUrl(`https://w${userInfo.sharding_key}.previewbuilder.com/api/r/${integrate_template._id}?${BuildRenderUrl(HOST, integrate_template._id, userInfo.secret_key, editableFields).split('?')[1]}`);
        }
    }, [integrate_template, editableFields, userInfo]);
    if (isLoading || error)
        return (_jsx("div", { style: { textAlign: 'center', marginTop: '20px' }, children: _jsx(Spinner, {}) }));
    return (_jsxs(Page, { title: 'Integrate template', secondaryActions: [
            {
                content: 'Delete template',
                accessibilityLabel: 'Delete template',
                onAction: () => {
                    setIsPromptModalOpen(true);
                },
            },
            {
                content: 'Edit template',
                onAction: () => navigate(`/edit_template/${props.id}`),
            },
        ], primaryAction: {
            content: 'Home',
            disabled: false,
            onAction() {
                navigate('/');
            },
        }, backAction: {
            content: 'Home',
            onAction() {
                if (query.from_edit) {
                    navigate(`/edit_template/${props.id}`);
                }
                else {
                    navigate('/');
                }
            },
        }, children: [PromptModal, ErrorModal, _jsx(Card, { roundedAbove: 'sm', children: _jsxs("div", { ref: containerRef, children: [_jsx("div", { style: {
                                width: `${cardSizes.width}px`,
                                height: `${cardSizes.height}px`,
                                position: 'relative',
                                border: 'solid 1px lightgrey',
                                boxSizing: 'border-box',
                            }, children: render.in_progress ? (_jsx("img", { src: loader_base64, style: {
                                    width: `24px`,
                                    height: `24px`,
                                    position: 'absolute',
                                    left: '50%',
                                    top: '50%',
                                } })) : (_jsx("img", { style: {
                                    width: `100%`,
                                    height: `100%`,
                                }, src: render.image })) }), _jsx("br", {}), _jsx(Text, { variant: 'headingLg', as: 'p', children: "Test your render! Just edit variable below and click Render." }), _jsxs("div", { style: { padding: '5px' }, children: [_jsx(Form, { onSubmit: () => {
                                        console.log('submit');
                                        setRenderUrl('');
                                        setRenderUrl(BuildRenderUrl(HOST, integrate_template._id, userInfo.secret_key, editableFields));
                                    }, children: _jsxs(FormLayout, { children: [editableFields.map((field) => (_jsx(TextField, { onChange: (newValue) => {
                                                    setEditableFields((prevFields) => {
                                                        return prevFields.map((i) => i.name !== field.name ? i : { ...i, value: newValue });
                                                    });
                                                }, value: field.value, label: field.name, type: "text", autoComplete: "off" }, field.name))), _jsx(Button, { variant: 'primary', submit: true, children: "Render" })] }) }), _jsx("br", {}), _jsxs("div", { children: [_jsx(Text, { variant: 'headingLg', as: 'p', children: "How to integrate templated preview into your site:" }), _jsx("br", {}), _jsx(IntegrateCard, { sharding_key: userInfo.sharding_key, template_id: integrate_template._id, secret_key: userInfo.secret_key, simple_key: integrate_template.simple_key, editableFields: editableFields })] })] })] }) }), _jsx(CrispSpacer, {})] }));
};
export default IntegrateTemplate;
